import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface ClosingSectionProps {
  isExpired: boolean;
}
export function ClosingSection({
  isExpired
}: ClosingSectionProps) {
  const price = isExpired ? '$47.00' : '$6.36';
  return <section className="py-12 px-4 bg-dark" data-id="element-44">
      <div className="max-w-[680px] mx-auto text-center space-y-[12px] text-base text-body leading-[1.5]" data-id="element-45">
        <p data-id="element-46">
          Ya sabías que algo tenía que cambiar. Esa sensación lleva tiempo ahí.
        </p>

        <p className="text-xl md:text-2xl font-serif text-gold font-bold mt-4 leading-[1.4]" data-id="element-47">
          La pregunta no es si necesitas un Reset. Es cuándo decides que ya es
          suficiente.
        </p>

        <p className="text-body font-medium mt-4" data-id="element-48">
          Hoy, {price} y 30 días pueden ser el punto de quiebre que tu versión
          futura te agradecerá toda la vida.
        </p>

        <p className="text-lg font-serif text-gold italic mt-4 mb-8" data-id="element-49">
          El costo de esperar no se mide en dólares.
        </p>

        <a href="https://pay.hotmart.com/J105033112F?off=ubpybkik" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-hover text-dark font-bold uppercase font-serif text-base py-[18px] px-9 rounded-md transition-colors shadow-[0_4px_20px_rgba(201,168,76,0.3)] hover:shadow-[0_4px_24px_rgba(201,168,76,0.4)] w-full md:w-auto" data-id="element-50">
          <span data-id="element-51">
            SÍ, ESTOY LISTO PARA
            <br data-id="element-52" />
            MI RESET
          </span>
          <ArrowRightIcon className="w-5 h-5 hidden md:block" data-id="element-53" />
        </a>
      </div>
    </section>;
}